/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Gefahrgutklasse } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * GefahrgutklasseService - axios parameter creator
 * @export
 */
export const GefahrgutklasseServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Gefahrgutklasse
         * @summary Gefahrgutklasse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGefahrgutklasseById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGefahrgutklasseById', 'id', id)
            const localVarPath = `/api/gefahrgutklasse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Gefahrgutklassen anhand der Suchkriterien
         * @summary Gefahrgutklassensuche
         * @param {string} [unnr] Gefahrgutklasse unnr
         * @param {string} [bezeichnung] Gefahrgutklasse Bezeichnung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGefahrgutklassen: async (unnr?: string, bezeichnung?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gefahrgutklasse/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (unnr !== undefined) {
                localVarQueryParameter['unnr'] = unnr;
            }

            if (bezeichnung !== undefined) {
                localVarQueryParameter['bezeichnung'] = bezeichnung;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GefahrgutklasseService - functional programming interface
 * @export
 */
export const GefahrgutklasseServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GefahrgutklasseServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Gefahrgutklasse
         * @summary Gefahrgutklasse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGefahrgutklasseById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Gefahrgutklasse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGefahrgutklasseById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Gefahrgutklassen anhand der Suchkriterien
         * @summary Gefahrgutklassensuche
         * @param {string} [unnr] Gefahrgutklasse unnr
         * @param {string} [bezeichnung] Gefahrgutklasse Bezeichnung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGefahrgutklassen(unnr?: string, bezeichnung?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Gefahrgutklasse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGefahrgutklassen(unnr, bezeichnung, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GefahrgutklasseService - factory interface
 * @export
 */
export const GefahrgutklasseServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GefahrgutklasseServiceFp(configuration)
    return {
        /**
         * Liefert eine Gefahrgutklasse
         * @summary Gefahrgutklasse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGefahrgutklasseById(id: number, options?: any): AxiosPromise<Gefahrgutklasse> {
            return localVarFp.getGefahrgutklasseById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Gefahrgutklassen anhand der Suchkriterien
         * @summary Gefahrgutklassensuche
         * @param {string} [unnr] Gefahrgutklasse unnr
         * @param {string} [bezeichnung] Gefahrgutklasse Bezeichnung
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGefahrgutklassen(unnr?: string, bezeichnung?: string, options?: any): AxiosPromise<Array<Gefahrgutklasse>> {
            return localVarFp.searchGefahrgutklassen(unnr, bezeichnung, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GefahrgutklasseService - interface
 * @export
 * @interface GefahrgutklasseService
 */
export interface GefahrgutklasseServiceInterface {
    /**
     * Liefert eine Gefahrgutklasse
     * @summary Gefahrgutklasse
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GefahrgutklasseServiceInterface
     */
    getGefahrgutklasseById(id: number, options?: any): AxiosPromise<Gefahrgutklasse>;

    /**
     * Liefert eine Liste von Gefahrgutklassen anhand der Suchkriterien
     * @summary Gefahrgutklassensuche
     * @param {string} [unnr] Gefahrgutklasse unnr
     * @param {string} [bezeichnung] Gefahrgutklasse Bezeichnung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GefahrgutklasseServiceInterface
     */
    searchGefahrgutklassen(unnr?: string, bezeichnung?: string, options?: any): AxiosPromise<Array<Gefahrgutklasse>>;

}

/**
 * GefahrgutklasseService - object-oriented interface
 * @export
 * @class GefahrgutklasseService
 * @extends {BaseAPI}
 */
export class GefahrgutklasseService extends BaseAPI implements GefahrgutklasseServiceInterface {
    /**
     * Liefert eine Gefahrgutklasse
     * @summary Gefahrgutklasse
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GefahrgutklasseService
     */
    public getGefahrgutklasseById(id: number, options?: any) {
        return GefahrgutklasseServiceFp(this.configuration).getGefahrgutklasseById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Gefahrgutklassen anhand der Suchkriterien
     * @summary Gefahrgutklassensuche
     * @param {string} [unnr] Gefahrgutklasse unnr
     * @param {string} [bezeichnung] Gefahrgutklasse Bezeichnung
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GefahrgutklasseService
     */
    public searchGefahrgutklassen(unnr?: string, bezeichnung?: string, options?: any) {
        return GefahrgutklasseServiceFp(this.configuration).searchGefahrgutklassen(unnr, bezeichnung, options).then((request) => request(this.axios, this.basePath));
    }
}
